import { createStore, applyMiddleware, compose } from 'redux';
import { thunk as thunkMiddleware } from 'redux-thunk';
import { SERGIC_OFFER } from './constants';
import createRootReducer from './reducers';
import { loadState } from './api/localStorage';
import { merge } from 'utils';
import { initialState as initialUiState } from 'reducers/ui';

const persistedState = loadState();

const store = createStore(
  createRootReducer(),
  merge(persistedState, { ui: { ...initialUiState, offer: SERGIC_OFFER } }),
  compose(
    applyMiddleware(thunkMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f,
  ),
);

export default store;
